import { useState, useRef, useEffect } from "react";
import StarhubLogo from "../../../assets/icons/starhubLogo";
import NotificationIcon from "../../../assets/icons/notification_icon";
import NotificationsData from "../../common/notifications/notificationsData";
import { useCentralStore } from "../../../store/appContext";
import { getUserManuals, isEmpty, toPascalCase } from "../../../utils/functionUtils";
import ActionTypes from "../../../store/actionTypes";
import API from "../../../api";
import CrossIcon from "../../../assets/icons/cross-icon";
import config from "../../../config/config";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import Logout from "../../../assets/icons/icon-logout"
import wordFile from '../../../assets/wordFiles/Reporting_tool-Device_protection_plan_User_Manual.docx'
import Download from "../../../assets/icons/downloadNew";
import { getCarrierByDomain } from "../../../domain";

const Header = ({ className, userDetails, resources }) => {
  const [
    {
      selectedTab,
      selectedClient,
      clientData,
      projectName,
      notificationsData,
      carrierThemeData,
      headeTitle
    },
    dispatch,
  ] = useCentralStore();
  const { theme } = carrierThemeData;

  const ref = useRef();

  const [notificationOpen, openNotification] = useState(false);
  const [name, setName] = useState(null);
  const [nameFlag, setNameFlag] = useState(false);

  let clientName = clientData
    ?.find((v) => v?.ClientId === selectedClient)
    ?.Client?.replaceAll("_", " ");
  clientName = clientName ? toPascalCase(clientName) : "";

  useEffect(() => {
    if (selectedTab) {
        setName(selectedTab)
    }
      
  }, [selectedTab]);

  const resetState = (isSGP) => {
    dispatch({ type: ActionTypes.SET_PROJECT_NAME, payload: null })
    dispatch({ type: ActionTypes.SET_PROGRAM_NAME, payload: undefined })
    dispatch({ type: ActionTypes.SET_SELECTED_TAB, payload: isSGP === 'true' ? null : "MAP" })
    dispatch({ type: ActionTypes.SGP_SET_REPORT_NAME, payload: {
      reportLabel: null,
      reportValue: null
    }})
    dispatch({ type: ActionTypes.SGP_SET_REPORT_FILTER_DURATION, payload: {
      type: null,
      startDate: null,
      endDate: null,
      duration: null
    }})
    dispatch({ type: ActionTypes.SGP_SET_REPORT_FILTER, payload: 'real time'})
    dispatch({ type: ActionTypes.GET_STARHUB_REPORT_COUNT_SUCCESS, payload: null})
    dispatch({ type: ActionTypes.GET_STARHUB_REPORT_COUNT_DETAILS_SUCCESS, payload: null})
    dispatch({ type: ActionTypes.GET_STARHUB_REPORT_DETAILS_SUCCESS, payload: null})
  }

  const _notificationsData = [
    {NotificationLabel : `Jun 2023 - Service Request Report available for download`},
    {NotificationLabel : "Mar 2023 - Service Request Report available for download"}
  ]

  const navigate = useNavigate();
  const handleClick = ()=>{
    API[ActionTypes.SIGNOUT_REQUEST]()
    .then((data) => {
        navigate('/login')
        dispatch({
          type: ActionTypes.SET_USER_LOGGED_IN,
          payload: false,
      });
      dispatch({
          type: ActionTypes.SET_EMAIL_ADDRESS,
          payload: "",
      });
      dispatch({
          type: ActionTypes.SET_PASSWORD,
          payload: "",
      });
      dispatch({
        type: ActionTypes.GET_STARHUB_REPORT_COUNT_SUCCESS,
        payload: undefined,
      });
      dispatch({
          type: ActionTypes.SET_SELECTED_TAB,
          payload: undefined,
      });
      dispatch({
          type: ActionTypes.SET_PROJECT_NAME,
          payload: undefined,
      });
      dispatch({
          type: ActionTypes.SET_PROGRAM_NAME,
          payload: undefined,
      });
        })
    .catch((err) => {
        console.log(`error is ${err}`);
        });
  }

  const handleDownload = (e, placeholder) => {
    const link = document.createElement('a');
    link.href = getUserManuals(getCarrierByDomain()?.toLowerCase())
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadReports = (e, placeholder) => {
    // navigate("/downloadReports");
    dispatch({ type: ActionTypes.SET_PROJECT_NAME, payload: 'Download Reports' });
    dispatch({ type: ActionTypes.SET_SELECTED_TAB, payload: undefined });
    dispatch({ type: ActionTypes.SET_PROJECT_SUB_MENU, payload: undefined });
  };

  const date = new Date()
  // var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
  // const prevMonth = `${months[date?.getMonth() - 1]} ${date?.getFullYear()}`
  var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];

  // Create a new Date object based on the input date
  const currentDate = new Date(date);
  
  // Get current month and year
  const currentMonth = currentDate.getMonth(); // Month (0-11)
  const currentYear = currentDate.getFullYear(); // Year

  // Calculate the previous month
  let prevMonthIndex = currentMonth - 1;
  let prevYear = currentYear;

  // Adjust if the previous month is before January
  if (prevMonthIndex < 0) {
      prevMonthIndex = 11; // December
      prevYear--; // Decrement year
  }

  // Get the name of the previous month
  const prevMonthName = months[prevMonthIndex];
  const prevMonth = `${prevMonthName} ${prevYear}`

  const dynamicStyle = {
    '--font-color': theme?.colors?.textWhiteColor,
    '--border-color': theme?.colors?.primary
  }
  
  return (
    // <div className={'mb-4'}>
      <div
        className={`${className} flex flex-row justify-between items-center w-[85%] mx-auto`}
      >
        <div className={`flex ${!nameFlag ? 'justify-start items-center w-full' : ''}`}>
            {/* <StarhubLogo className="w-14 m-2 h-[50px] cursor-pointer" onClick={() => resetState(config.isSGP)} /> */}
            <img className="max-w-18 m-1 h-[40px] cursor-pointer" onClick={() => resetState(config.isSGP)} src={theme?.logo} />
            <p className={'starhubHeader text-black justify-start'}>{carrierThemeData?.program}</p>
          {/* {!nameFlag && 
          <p
            className={'starhubHeader text-black ml-4 justify-start'}
          >
            {`${
             !isEmpty(headeTitle) ? headeTitle?.replace('Program Summary', `Program Summary - ${prevMonth}`)?.replace('Program Overview', `Program Overview - ${prevMonth}`)
                : name
            }`}
          </p>
          } */}
        </div>
        {nameFlag &&
        <p className="font-bold text-[32px]">
          {
            selectedTab === 'Monthly Trends'
            ? "Monthly Trends"
            : name
          }
        </p>
          // <marquee behavior="alternate" className="font-bold text-2xl">{name}</marquee>
        }
        <div className={`flex flex-row justify-end ${!nameFlag ? 'w-full' : 'min-w-max'}`}>
          {/* {projectData?.Notifications?.length > 0 && ( */}
          {/* <div className="relative">
            {((notificationsData?.length > 0  && selectedTab === 'MAP') || _notificationsData.length > 0) && (
              <div
                class="relative inline-flex items-center text-sm font-medium text-white mr-7"
                onClick={() => openNotification(true)}
              >
                <NotificationIcon className="mr-2 cursor-pointer" />
                <div class="cursor-pointer animate-bounce absolute inline-flex items-center justify-center text-10px text-white bg-red-500 border border-white rounded-full -top-1 -right-0.5 dark:border-gray-900 h-5 w-5">
                  {notificationsData?.length || _notificationsData?.length}
                </div>
              </div>
            )}
            {notificationOpen && (
              <div
                ref={ref}
                className={`absolute right-20% w-max flex flex-col text-14 z-50 max-h-550px overflow-y-scroll scroll-body`}
              >
                <div className={`rounded-2xl p-1 text-sm leading-20 bg-slate-100 mb-px w-92  flex flex-col justify-between`}>
                  <div className={`border border-[#D5D6DA] shadow-lg rounded-2xl py-2 px-3 text-sm leading-20 bg-slate-100 mb-px  flex flex-col justify-between`}>
                    <div className="py-2 flex justify-between static mb-2">
                      <div className={`text-black text-lg`}>Notifications</div>
                      <div
                        className={`cursor-pointer px-2 py-1 ml-3 flex items-center hover:bg-slate-300 hover:rounded-lg`}
                        onClick={() => openNotification(false)}
                      >
                        <CrossIcon fill="#A5AAAF" className="w-3 h-3" />
                      </div>
                    </div>
                    {_notificationsData?.map((item) => (
                      <NotificationsData
                        notifications={item}
                        resources={resources}
                        handleDownloadReports={handleDownloadReports}
                      />
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div> */}
          <div className="flex flex-row items-center">
            {/* <div className={'bg-white p-1 text-center rounded-full text-black mr-2 font-bold text-sm'}>
              {userDetails && userDetails?.firstName?.split()?.[0]?.charAt(0)?.toUpperCase()}
              {userDetails && userDetails?.lastName?.split()?.[0]?.charAt(0)?.toUpperCase()}
            </div> */}
            <div className={'text-base font-bold'}>
              <span className="textFontStyle" style={dynamicStyle}>{userDetails && toPascalCase(userDetails?.firstName)}{" "}{userDetails && toPascalCase(userDetails?.lastName)}</span>
              <span className="textFontStyle" style={dynamicStyle}>{userDetails && toPascalCase(userDetails?.split('@')[0]?.split('.')[0]) + ' ' + toPascalCase(userDetails?.split('@')[0]?.split('.')[1])}</span>
            </div>
            <div onClick={handleDownload} className="flex flex-row float-right cursor-pointer gap-1 mx-3">
              <Download className="h-4 w-4 mt-1"/>
              <p onClick={handleDownload} className="text-base font-bold flex float-right text-right textFontStyle hover:text-gray-500 cursor-pointer" style={dynamicStyle}>Download user manual here</p>
            </div>
            <p 
              className='flex items-center float-right textFontStyle text-base cursor-pointer hover:text-gray-500 font-bold' 
              onClick={handleClick}
              style={dynamicStyle}
              >
                <Logout className="ml-2"/>
                Logout 
            </p>
            {/* <Button 
              className='flex items-center borderStyle float-right cursor-pointer text-black hover:text-gray-400 font-bold' 
              onClick={handleClick}
              style={dynamicStyle}
              >
                Logout 
                <Logout className="ml-2"/>
            </Button> */}
          </div>
        </div>
      </div>
      
        // {/* <> */}
          // {/* <div onClick={handleDownload} className="flex flex-row float-right -mt-2 cursor-pointer gap-1 mr-3">
          //   <p onClick={handleDownload} className="text-sm font-bold flex float-right text-right textFontStyle hover:text-gray-300 cursor-pointer underline" style={dynamicStyle}>Download user manual here!! </p>
          //   <Download fill={theme?.colors?.primary} className="pt-2px h-5 w-5"/>
          // </div> */}
    //       {/* <div onClick={handleDownloadReports} className="flex flex-row float-right -mt-2 cursor-pointer gap-1 mr-3">
    //         <p projectName="Download Reports" 
    //           onClick={handleDownloadReports} 
    //           className={`text-sm font-bold flex float-right text-right textFontStyle hover:text-gray-300 cursor-pointer underline`}
    //           style={dynamicStyle}>
    //             Download Reports Here!!
    //           </p>
    //         <Download fill={theme?.colors?.primary} className="pt-2px h-5 w-5"/>
    //       </div> */}
    //     {/* </> */}
      
    // </div>
  );
};

export default Header;